export default __webpack_public_path__ + "static/media/calendar-check-fill.2e78cbe6.svg";